import { IconType } from '@/components/view/atoms/icon/Icon'
import IconText from '@/components/view/atoms/icon/IconText'
import GuidanceAreaContent from '@/components/view/layouts/area/GuidanceAreaContent'

const PageListSearching = () => {
  return (
    <GuidanceAreaContent>
      <IconText text='検索中' iconType={IconType.LOADING} />
    </GuidanceAreaContent>
  )
}

export default PageListSearching
